/**
 * 文件定位：
 * 1. 当前文件位于 cad-core/mesh/feature/revolve 层；
 * 2. 负责定义旋转角度手柄的可拾取部件类型；
 * 3. 该枚举供手柄对象与拖拽控制器共享，避免通过 userData 传递语义。
 */

/**
 * 旋转角度手柄部件类型。
 */
export enum RevolveAngleGizmoPartKind {
    /** 方向 1 角度拖拽头。 */
    Direction1Head = 'direction1Head',
    /** 方向 2 角度拖拽头。 */
    Direction2Head = 'direction2Head',
}
